import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
var _excluded = ["fullWidth", "variant"];
var _templateObject;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { GRAY } from "../../constants/colors/hex";
import { Card } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _Card = styled(function (_ref) {
  var fullWidth = _ref.fullWidth,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Card, props, props.children);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & {\n    display: ", ";\n    border: ", ";\n\n    &.MuiCard-root {\n      box-shadow: ", ";\n    }\n  }\n"])), function (props) {
  return props.fullWidth ? 'block' : 'inline-block';
}, function (props) {
  return props.variant === 'plain' ? 'none' : "solid 1px ".concat(GRAY[18]);
}, function (props) {
  return props.variant === 'elevated' ? '0px 2px 8px rgba(59, 65, 83, 0.18), 0px 0px 2px rgba(59, 65, 83, 0.14), 0px 2px 4px rgba(59, 65, 83, 0.12)' : 'none';
});